import React, { useEffect, useState } from "react";
import Footer from "./Footer";
import NavBar from "./NavBar";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { LoaderCircle, Pencil } from "lucide-react";
import Loading from "./Loading";
import InputAdd from "../components/Inputs/InputAdd";

export default function DetalhesUsuario() {
  const [detalhe, setDetalhe] = useState({});
  const [dataSubscricao, setDataSubscricao] = useState("");
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [naoHaDados, setNaoHaDados] = useState(false)
  const [nome, setNome] = useState("");
  const [contacto, setContacto] = useState("");
  const [endereco, setEndereco] = useState("");
  const [nuit, setNuit] = useState("");
  const [plano, setPlano] = useState("");
  const [data, setData] = useState("");
  const [usuario, setUsuario] = useState("");
  const [colaborador, setColaborador] = useState("");
  const [clicado, setClicado] = useState(false);
  const [mensagem, setMensagem] = useState("");
  const [atualizando, setAtualizando] = useState(false);
  const navigate = useNavigate();

  function formatarDataISO(dataISO) {
    if (!dataISO) return null;

    const data = new Date(dataISO);
    const ano = data.getFullYear();
    const mes = String(data.getMonth() + 1).padStart(2, "0");
    const dia = String(data.getDate()).padStart(2, "0");

    return `${dia}-${mes}-${ano}`;
  }

  function formatarData(dataISO) {
    if (!dataISO) return null;

    const data = new Date(dataISO);
    const ano = data.getFullYear();
    const mes = String(data.getMonth() + 1).padStart(2, "0");
    const dia = String(data.getDate()).padStart(2, "0");

    return `${ano}-${mes}-${dia}`;
  }

  async function mostrarDetalhesUsuario() {
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("token"));
    try {
      const resposta = await axios.get(
        `https://api-eyazs-production-8f74.up.railway.app/detalheusuario/${id}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,  // Substitua pelo seu token de autenticação, se necessário
            'Content-Type': 'application/json'         // Define o tipo de conteúdo como JSON
          }
        }
      );      
      // Verifica se a resposta contém os dados esperados
      if (resposta.data.detalhe) {  
        // Define os estados com valores padrão caso as propriedades estejam ausentes
        setDetalhe(resposta.data.detalhe);
        setUsuario(resposta.data.detalhe.nome);
        console.log(resposta.data.detalhe.nome)
        setNome(resposta.data.detalhe.nome || "");
        setContacto(resposta.data.detalhe.contacto || "");
        setEndereco(resposta.data.detalhe.endereco || "");
        setNuit(resposta.data.detalhe.nuit || "");
        setPlano(resposta.data.detalhe.plano || "");
        setData(resposta.data.detalhe.dataSubscricao || "");
        setColaborador(resposta.data.detalhe.colaboradorAssociado || "");
        setDataSubscricao(
          resposta.data.detalhe.dataSubscricao ? formatarDataISO(resposta.data.detalhe.dataSubscricao) : ""
        );
      } else {
        setNaoHaDados(true)
        console.warn("Dados não disponíveis ou incompletos:", resposta.data.detalhe);
      }
    } catch (erro) {
      console.error("Erro ao buscar detalhes do usuário:", erro);
    } finally {
      setLoading(false);
    }
  }

  async function atualizarCliente() {
    setAtualizando(true);
    if (!nome || !contacto || !nuit || !endereco || !data || !colaborador) {
      setMensagem("Por favor, preencha todos os campos obrigatórios.");
      setAtualizando(false);
      return;
    }

    try {
      const response = await axios.put(
        `https://api-eyazs-production-8f74.up.railway.app/detalhe/${detalhe.idDetalhe}`,
        {
          idUsuario: detalhe.idUsuario,
          nome:nome,
          contacto:contacto,
          dataSubscricao: formatarData(data),
          endereco:endereco,
          nuit:nuit,
          colaboradorAssociado: colaborador
        }
      );

      if (response.status === 200) {
        alert("Usuário atualizado com sucesso!");
        resetForm();
      } else {
        setMensagem("Houve um erro ao atualizar o cliente.");
      }
    } catch (erro) {
      console.error("Erro ao Atualizar o cliente:", erro);
      setMensagem("Erro ao Atualizar cliente. Tente novamente.");
    } finally {
      setAtualizando(false);
    }
  }

  function resetForm() {
    setNome("");
    setContacto("");
    setEndereco("");
    setNuit("");
    setData("");
    setColaborador("");
    setMensagem("");
  }

  useEffect(() => {
    mostrarDetalhesUsuario();
    console.log(usuario)
  }, []);

  const propsInputNome = {
    type: "text",
    placeholder: "Nome",
    mudar: (e) => setNome(e.target.value),
    value: nome,
  };
  const propsInputContacto = {
    type: "text",
    placeholder: "Contacto",
    mudar: (e) => setContacto(e.target.value),
    value: contacto,
  };
  const propsInputEndereco = {
    type: "text",
    placeholder: "Endereço",
    mudar: (e) => setEndereco(e.target.value),
    value: endereco,
  };
  const propsInputNuit = {
    type: "text",
    placeholder: "Nuit",
    mudar: (e) => setNuit(e.target.value),
    value: nuit,
  };
  const propsInputData = {
    type: "date",
    placeholder: "Data",
    mudar: (e) => setData(e.target.value),
    value: data,
  };
  const propsInputColab = {
    type: "text",
    placeholder: "Colaborador Associado",
    mudar: (e) => setColaborador(e.target.value),
    value: colaborador,
  };

  return (
    <div className="flex flex-col justify-between min-h-screen">
      <div className="bg-blue-500 h-[180px] sticky top-0 z-10">
        <NavBar />
      </div>
      {loading ? (
        <div className="z-0">
          <Loading />
        </div>
      ) : (
        <div className="flex justify-center px-4 sm:px-8 z-0">
          {clicado ? (
            <div className="flex justify-center flex-grow p-4">
              <div className="w-full max-w-4xl border py-6 rounded-xl bg-white shadow-md">
                <div className="w-[90%] mx-auto flex flex-col">
                  <div className="mx-auto border rounded-xl bg-gray-50 m-2 p-2 py-4 w-full">
                    <h2 className="mx-auto text-[20px] lg:text-[25px] text-center">
                      Atualizar Cliente
                    </h2>
                  </div>
                  <div className="m-1">
                    <InputAdd {...propsInputNome} />
                  </div>
                  <div className="flex flex-wrap gap-2 m-1">
                    <div className="w-full sm:w-[49%]">
                      <InputAdd {...propsInputContacto} />
                    </div>
                    <div className="w-full sm:w-[49%]">
                      <InputAdd {...propsInputEndereco} />
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-2 m-1">
                    <div className="w-full sm:w-[99%]">
                      <InputAdd {...propsInputNuit} />
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-2 m-1">
                    <div className="w-full sm:w-[49%]">
                      <InputAdd {...propsInputData} />
                    </div>
                    <div className="w-full sm:w-[49%]">
                      <InputAdd {...propsInputColab} />
                    </div>
                  </div>
                  {atualizando ? (
                    <button className="w-full mt-4 bg-blue-500 p-2 text-white rounded-lg">
                      <div className="flex justify-center items-center gap-1">
                        <span>Processando</span>
                        <LoaderCircle
                          strokeWidth={4}
                          size={18}
                          className={atualizando ? "animate-spin text-white" : ""}
                        />
                      </div>
                    </button>
                  ) : (
                    <button
                      onClick={() => atualizarCliente()}
                      className="w-full mt-4 bg-blue-500 p-2 hover:bg-blue-400 text-white rounded-lg"
                    >
                      Atualizar
                    </button>
                  )}
                  {mensagem && (
                    <p className="bg-red-800 py-2 text-center font-semibold text-yellow-400 rounded-lg my-2">
                      {mensagem}
                    </p>
                  )}
                </div>
              </div>
            </div>
          ) : naoHaDados ?
          <div className="flex mt-6 items-center justify-center h-1/2 shadow-lg bg-gray-100">
          <div className="p-6 max-w-md bg-white shadow-lg rounded-lg text-center border border-gray-200">
            <h1 className="text-2xl font-semibold text-red-600">
              Não há detalhes do usuário 
              <span className="text-gray-800"> {nome}</span>
            </h1>
            <p className="text-gray-600 mt-2">
              Verifique se o usuário está registrado ou tente novamente mais tarde.
            </p>
            <button
              onClick={() => navigate(-1)}
              className="mt-4 bg-blue-500 text-white px-8 py-2 rounded-lg hover:bg-blue-600"
            >
              Voltar
            </button>
          </div>
        </div>
        :  
          (
            <div className="overflow-x-auto mt-4">
            <table className="min-w-full text-sm text-left text-gray-500">
              <thead className="bg-gray-200">
                <tr>
                  <th className="border px-4 py-3 text-center">Nome</th>
                  <th className="border px-4 py-3 text-center">Contacto</th>
                  <th className="border px-4 py-3 text-center">Endereço</th>
                  <th className="border px-4 py-3 text-center">NUIT</th>
                  <th className="border px-4 py-3 text-center">Data Subscrição</th>
                  <th className="border px-4 py-3 text-center">Colaborador</th>
                  <th className="border px-4 py-3 text-center">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border px-4 py-3 text-center">{detalhe.nome}</td>
                  <td className="border px-4 py-3 text-center">{detalhe.contacto}</td>
                  <td className="border px-4 py-3 text-center">{detalhe.endereco}</td>
                  <td className="border px-4 py-3 text-center">{detalhe.nuit}</td>
                  <td className="border px-4 py-3 text-center">{dataSubscricao}</td>
                  <td className="border px-4 py-3 text-center">{detalhe.colaboradorAssociado}</td>
                  <td className="border px-4 py-3 text-center">
                    <button
                      className="text-blue-600"
                      onClick={() => setClicado(true)}
                    >
                      <Pencil />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          )}
        </div>
      )}
      <Footer />
    </div>
  );
}
